<template>
    <div v-if="searches.length > 0">
        <span class="badge bg-warning"><i class="fa fa-times" title="clear all" @click="clearAll"></i> Clear All</span>
        <span class="badge bg-warning" v-for="(item, index) in searches" :key="index"><i class="fa fa-times" title="clear" @click="item.removeCallback"></i> {{item.title}}</span>
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import {rentAmountPerList} from "../../api/static_data";
import {useSubmitSearch} from "../../composables/useSubmitSearch";
import {useSearchStore} from "../../store/search";

export default {
    name: "SelectedSearchBar",
    setup() {
        const searchStore = useSearchStore();

        const {submitSearch} = useSubmitSearch();

        let searches = ref([]);

        const setSearches = function () {

            setTimeout(() => {
                searches.value.length = 0;

                const staticData = window.localStorage.getItem("static_data") ? JSON.parse(window.localStorage.getItem("static_data")) : null;

                for(let key in searchStore.searchParams) {
                    if (searchStore.searchParams[key]) {
                        if (key !== "range_fields" && key !== "features") {
                            if (key === "country") {
                                if(staticData) {
                                    searches.value = [...searches.value, {
                                        title: (staticData.areas.find(a => a.id == searchStore.searchParams[key])).name,
                                        removeCallback: () => {
                                            searchStore.$patch({
                                                searchParams: {
                                                    ...searchStore.searchParams,
                                                    country: 0,
                                                    state: 0,
                                                    city: 0
                                                }
                                            });

                                            submitSearch();
                                        }
                                    }];
                                }
                            } else if (key === "state") {
                                if(staticData) {
                                    const countryAreas = staticData.areas.find(a => a.id == searchStore.searchParams.country);

                                    searches.value = [...searches.value, {
                                        title: (countryAreas.states.find(s => s.id == searchStore.searchParams[key])).name,
                                        removeCallback: () => {
                                            searchStore.$patch({
                                                searchParams: {
                                                    ...searchStore.searchParams,
                                                    state: 0,
                                                    city: 0
                                                }
                                            });

                                            submitSearch();
                                        }
                                    }];
                                }
                            } else if (key === "city") {
                                if(staticData) {
                                    const countryAreas = staticData.areas.find(a => a.id == searchStore.searchParams.country);
                                    const stateAreas = countryAreas.states.find(s => s.id == searchStore.searchParams.state);

                                    const area = stateAreas.cities.find(s => s.id == searchStore.searchParams[key]);

                                    if(area) {
                                        searches.value = [...searches.value, {
                                            title: area.name,
                                            removeCallback: () => {
                                                searchStore.$patch({
                                                    searchParams: {
                                                        ...searchStore.searchParams,
                                                        city: 0
                                                    }
                                                });

                                                submitSearch();
                                            }
                                        }];
                                    }

                                }
                            } else if(key === "rent_amount_per") {
                                searches.value = [...searches.value, {
                                    title: (rentAmountPerList.find(r => r.id == searchStore.searchParams[key])).name,
                                    removeCallback: () => {
                                        searchStore.searchParams.rent_amount_per = "";

                                        submitSearch();
                                    }
                                }];
                            } else {
                                searches.value = [...searches.value, {
                                    title: searchStore.searchParams[key],
                                    removeCallback: () => {
                                        if(key === "keyword") {
                                            searchStore.searchParams.keyword = "";
                                        }

                                        if(key === "status") {
                                            searchStore.searchParams.status = "";
                                        }

                                        if(key === "property_finalizing") {
                                            searchStore.searchParams.property_finalizing = "";
                                        }

                                        submitSearch();
                                    }
                                }];
                            }
                        } else if (key === "features") {
                            if(staticData) {
                                const selectedFeatures = searchStore.searchParams[key].map(fid => {
                                    return {
                                        title: (staticData.features.find(s => s.id == fid)).title,
                                        removeCallback: () => {
                                            searchStore.removeSearchFeature(fid);


                                            submitSearch();
                                        }
                                    }
                                });

                                searches.value = [...searches.value, ...selectedFeatures];
                            }
                        } else if (key === "range_fields") {
                            for (let rangeKey in searchStore.searchParams[key]) {
                                if (searchStore.searchParams[key][rangeKey].min || searchStore.searchParams[key][rangeKey].max) {
                                    searches.value = [...searches.value, {
                                        title: (rangeKey + `:${searchStore.searchParams[key][rangeKey].min}, ${searchStore.searchParams[key][rangeKey].max}`),
                                        removeCallback: () => {
                                            searchStore.setSearchRange({field: rangeKey, value: {min: 0, max: 0}});

                                            submitSearch();
                                        }
                                    }];
                                }
                            }
                        }
                    }

                }

            }, 300);
        }

        const clearAll = function () {
            searchStore.setSearchDefaults();

            submitSearch();
        }

        onMounted(() => setSearches());

        watch(() => searchStore.searchParams, (newVal, oldVal) => {
            setSearches();
        }, {deep: true});

        return {
            searches,
            clearAll
        }
    }
}
</script>

<style scoped>
div {
    margin-bottom: 20px;
}
.bg-warning {
    background-color: #ccaf14 !important;
    margin: 5px;
}
.fa-times {
    cursor: pointer;
}
</style>
